import { InferGetServerSidePropsType } from 'next';

import NewsDetail from '@/components/dashboard/news/NewsDetail';
import { getServerSideNewsDetail } from '@/redux/news/newsServer';

const CryptoNewsDetail = ({ newsDetail }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return <NewsDetail detail={newsDetail} />;
};

export const getServerSideProps = getServerSideNewsDetail();

export default CryptoNewsDetail;
